// extracted by mini-css-extract-plugin
module.exports = {"modal_footer_contents":"_20MfChq"};